import Image from 'app/Components/Shared/Image/image';

import React, { useEffect, useState } from 'react';
import PackageBox from './packageBox';
import Config from '../../../../../Config';

const PackageBoxList = (props) => {

    return (<div className='premium-package-box-list'>
        {props.selectedTab == 'newPackages' ?
            (props.premiumPackagesByGroups && (Object.keys(props.premiumPackagesByGroups).length > 1) ?
                Object.keys(props.premiumPackagesByGroups).map(function (key) {
                    const categoryList = props.premiumPackagesByGroups[key];
                    const categoryName = key;
                    let categoryIcon = categoryList[0].cmsData?.categories.find(category => category.categoryName == key)?.categoryIcon ?? null;
                    return (
                        <div key={key} className='category-wrapper'>
                            {categoryName && <div className='category'>{categoryIcon && <Image className='category-icon' src={Config.epiBaseUrl + categoryIcon} alt='category icon' />} {categoryName}</div>}
                            <div className='premium-package-list'>
                                {categoryList.map(function (item, index) {
                                    return (<PackageBox key={index} defaultImage={props.defaultImage} type={props.selectedTab} package={item} onClick={props.onClickPackage} />);
                                })}
                            </div>
                        </div>
                    )
                }) :
                <div className='premium-package-list'>
                    {props.availablePackages?.map(function (item, index) {
                        return (<PackageBox key={index} defaultImage={props.defaultImage} type={props.selectedTab} package={item} onClick={props.onClickPackage} />);
                    })}
                </div>
            ) :
            <div className='premium-package-list'>
                {props.installedPackages?.map(function (item, index) {
                    return (<PackageBox key={index} defaultImage={props.defaultImage} type={props.selectedTab} package={item} onClick={props.onClickPackage} onHboRegistrationClick={props.onHboRegistrationClick} onDisneyRegistrationClick={props.onDisneyRegistrationClick} />);
                })}
            </div>
        }
    </div>
    );

}
export default PackageBoxList;
